import { render, staticRenderFns } from "./About.vue?vue&type=template&id=13309399&scoped=true"
import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=13309399&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13309399",
  null
  
)

export default component.exports